export default __webpack_public_path__ + "static/media/Accessories_preview.d4bdd366.gif";